<template>
    <div ref="aiImageRef" class="ai-container" :style="drag.style.value" @click="openChatAI()">
        <img :src="getAIDialogUrl()" alt="" />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useDraggable } from "@vueuse/core";
import { openConsoleAdminPage } from "@/utils/common";
import Tenant from "@/function/tenant";
import { CDN_URL } from "@/utils/config";

const aiImageRef = ref<HTMLElement>();

/** 是否有拖拽 */
const hasDragging = ref(false);

/** 自动吸附到屏幕边缘 */
const resetPosition = () => {
    if (drag.y.value > window.innerHeight - 156) {
        drag.y.value = window.innerHeight - 156;
    } else if (drag.y.value < 0) {
        drag.y.value = 0;
    }
    if (drag.x.value > document.body.clientWidth / 2 - 30) {
        drag.x.value = document.body.clientWidth - 63;
    } else {
        drag.x.value = 0;
    }
};

// 拖拽
const drag = useDraggable(aiImageRef, {
    preventDefault: true,
    initialValue: { x: document.body.clientWidth - 63, y: window.innerHeight - 416 },
    onMove: () => {
        console.log("onMove");

        hasDragging.value = true;
    },
    onEnd: () => {
        // 放开后，自动吸附到屏幕边缘
        resetPosition();
    }
});

const getAIDialogUrl = () => {
    const isChainCloud = Tenant.getInstance().isChainCloud;
    if (isChainCloud) {
        return CDN_URL + "customer-admin/ai-dolls-blue.png";
    } else {
        return Tenant.getInstance().theme.AIImage;
    }
};

const openChatAI = () => {
    // 防止拖拽时，触发点击事件
    if (hasDragging.value) {
        hasDragging.value = false;
        return;
    }

    openConsoleAdminPage("/chatAI");
};

const resizeListener = () => {
    // 修改窗口大小后，如果不在屏幕内，自动重定位
    resetPosition();
};

onMounted(() => {
    window.addEventListener("resize", resizeListener);
});
onUnmounted(() => {
    window.removeEventListener("resize", resizeListener);
});
</script>

<style scoped lang="scss">
.ai-container {
    position: fixed;
    cursor: pointer;
    z-index: 1000;
    img {
        width: 60px;
    }
}
</style>
